export type CssClassMap = { [className: string]: boolean }
